module.exports = __webpack_public_path__ + "media/images/shared/icon_insta-35046ac21f36d900942920c331a15a13.png";